<div class="container d-none d-lg-block py-3">
  <div class="rewards-back-button bg-glass-dark cursor-pointer" (click)="location.back()">
    <span class="material-icons align-middle text-white">arrow_back_ios_new</span>
  </div>
</div>

<!-- Points Summary -->
<fgb-points-summary-bar [marketplaceItemGroup]="marketplaceItemType().group"></fgb-points-summary-bar>

<!-- Details -->
<fgbcl-marketplace-details-v2 [itemId]="id"></fgbcl-marketplace-details-v2>
